import { Box, Typography } from "@mui/material";
import { BryceLapRacer } from "./lapRacer/BryceLapRacer";

export function BryceSimpleCompetitionV1() {
  return <Box sx={{ width: "100%" }}><BryceLapRacer /></Box>;
}

export function BryceSimpleCompetitionV2() {
  return <Box><Typography>Bryce V2 Placeholder</Typography></Box>;
}

export function BryceSimpleCompetitionV3() {
  return <Box><Typography>Bryce V3 Placeholder</Typography></Box>;
}
